const snackbarMixin = {
  data() {
    return {
      snackbar: {
        color: 'primary',
        text: '',
        active: false
      }
    };
  }
};

export default snackbarMixin;
